export const listingDescriptionStageId = "listing-description-stage-vehicle-details"
